export enum ENVIRONMENT {
  DEVELOPMENT = 'development',
  LOCAL = 'local',
  PRODUCTION = 'production',
  STAGING = 'staging',
  TEST = 'test',
}

export enum CUSTOMER_PORTAL_DOMAINS {
  BASE_DOMAIN = 'portal.fleetpanda.com',
}

export enum SERVER_ENVIRONMENT {
  DEV = 'dev',
  PROD = 'prod',
  UAT = 'uat',
}
